<template>
	<div class="panel_shouyin">
		<div class="titleLine">
			<el-row>
				<el-col :span="2" :offset="22">
					<el-button @click="add" size="mini">新建挂号</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="listLine">
			<el-table :data="tableData" style="width: 100%" @sort-change="changeSort" :default-sort = "{prop: 'createTime', order: 'descending'}">
				<el-table-column label="挂号单号" width="180">
					<template slot-scope="scope">
						{{scope.row.recordId}}
					</template>
				</el-table-column>
				<el-table-column label="宠物">
					<template slot-scope="scope">
						{{scope.row.petName}}
					</template>
				</el-table-column>
				<el-table-column label="医生" width="110">
					<template slot-scope="scope">
						{{scope.row.doctorName}}
					</template>
				</el-table-column>
				<el-table-column label="挂号时间" width="150" :sortable="'custom'" prop="createTime">
					<template slot-scope="scope">
						{{$public.FTime(scope.row.createTime,'YYYY-MM-DD HH:mm:ss')}}
					</template>
				</el-table-column>
				<el-table-column label="状态" width="80">
					<template slot-scope="scope">
						<span v-if="scope.row.isPay===false">
							<span style="color:red;">待支付</span>
						</span>
						<span v-else>
							<span v-if="scope.row.status===1">待接诊</span>
							<span v-if="scope.row.status===2">已接诊</span>
							<span v-if="scope.row.status===3">已完成</span>
						</span>
					</template>
				</el-table-column>
				<el-table-column label="备注" width="100">
					<template slot-scope="scope">
						{{scope.row.remark}}
					</template>
				</el-table-column>
				<el-table-column label="销售人员" width="120">
					<template slot-scope="scope">
						<span v-for="item in scope.row.saleMan" :key="item">{{item+' '}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="150">
					<template slot-scope="scope">
						<el-button type="text" @click="see(scope.row)">查看</el-button>
						<el-button v-if="scope.row.isPay===false" @click="pay(scope.row)" type="text" size="small">结算</el-button>
						<el-button v-if="scope.row.isPay===false" @click="del(scope.row)" type="text" size="small">删除记录</el-button>
						<el-button v-if="scope.row.isPay===true&&scope.row.status===1" @click="cancel(scope.row)" type="text" size="small">取消订单</el-button>
					</template>
				</el-table-column>
				<span slot="empty">
					<img src="../../../../assets/img/konging.png" style="width:271px;margin-top:100px;"/>
					<div style="font-size: 16px;color:#999;margin:20px;">这个人什么痕迹都没留下</div>
				</span>
			</el-table>
			<page :page="page.page" :total="page.total" @change="changePage"></page>
		</div>
		<guahaoSee v-if="drawerGuahaoSee_state" :curItem="curItem" @submit="submit_drawerGuahaoSee"></guahaoSee>
		<!-- 结算 -->
		<div v-if="dialogSettlementState">
			<dialogSettlement :orderId="curOrder.orderNum" @submit="dialogSettlementSubmit"></dialogSettlement>
		</div>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	import guahaoSee from "../drawer/guahaoSee.vue"
	import dialogSettlement from "../../../../components/dialog_settlement.vue"
	export default {
		components:{page,guahaoSee,dialogSettlement},
		data(){
			return{
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData:[],
				desc:true,
				// see
				drawerGuahaoSee_state:false,
				curItem:{},
				// 结算
				dialogSettlementState: false,
				curOrder: {},
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			curPetId(){
				return this.$store.state.mendian.curPetId;
			},
			curPetInfo(){
				return this.$store.getters['mendian/curPetInfo'];
			},
		},
		watch:{
			curPetInfo(){
				this.getTableData()
			}
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			add(){
				this.$store.commit('guahao/set_type','add')
			},
			see(row){
				this.drawerGuahaoSee_state = true;
				this.curItem = row;
			},
			submit_drawerGuahaoSee(){
				this.drawerGuahaoSee_state = false;
			},
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			// 获取列表
			getTableData() {
				let params = {
					"status": 0, // 1待接诊；2已接诊；3已完成
					"is_mine": false,
					"memberId": this.userInfo._id,
					"begin_time": "",
					"end_time": "",
					"departmentId": 0,
					"isTransfer": 0,
					// isPay:1,
					desc:this.desc,
					"keyword": "",
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				let loading = this.$loading()
				this.$http.post('/api/Registration/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			// 挂号顺序
			changeSort(val){
				if(val.order==='ascending'){
					this.desc = false
					this.getTableData();
				}else if(val.order==='descending'){
					this.desc = true
					this.getTableData();
				}else{
					this.desc = false
					this.getTableData();
				}
			},
			// 结算
			pay(row) {
				this.curOrder = row
				this.dialogSettlementState = true;
			},
			// 删除挂号记录
			del(row){
				this.$confirm('确定删除这条挂号记录吗?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						"order_id": row.orderNum,
					}
					let loading = this.$loading()
					this.$http.get('/api/Order/ReceivedOrder', params).then(res => {
						loading.close()
						if (res.code == 0) {
							this.$message({
								message: '操作成功！',
								type: 'success'
							});
							this.getTableData();
						}
					})
				})
			},
			// 取消订单
			cancel(row){
				this.$confirm('仅取消挂号记录，不涉及到挂号费退款，如要退款，请到订单管理中申请退款操作。确定取消吗?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						"recordId": row.recordId,
					}
					let loading = this.$loading()
					this.$http.delete('/api/Registration/Delete', params).then(res => {
						loading.close()
						if (res.code == 0) {
							this.$message({
								message: '操作成功！',
								type: 'success'
							});
							this.getTableData();
						}
					})
				})
			},
			dialogSettlementSubmit(a) {
				this.dialogSettlementState = false;
				if (a == 'close') {
					console.log(a)
				} else if (a == 'fail') {
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				} else if (a == 'success') {
					this.$message({
						message: '结算成功',
						type: 'success'
					});
				}
				this.getTableData();
			},
		},
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	height: 100%;background-color: #fff;padding:45px 0 0;box-sizing: border-box;position: relative;
	.titleLine{
		width:100%;
		background-color: #fff;
		height: 44px;
		padding:10px 8px 12px;
		box-sizing: border-box;
		position: absolute;
		top:0;
	}
	.listLine{
		height: 100%;padding:0 0px 60px 0px;box-sizing: border-box;
	}
	.pageLine{
		position: absolute;bottom:0;z-index: 1;width:100%;padding:10px;background-color: #fff;box-sizing: border-box;
	}
}
</style>
